export const getSelectedBusiness = state => state.businessData.selectedBusiness;
export const getMarkers = state => state.businessData.markers;
export const getAllBusinesses = state => state.businessData.allBusinesses;
export const getBusinessId = state=>state.businessData.selectedBusiness?._id;
export const getServices =state => state.businessData.selectedBusiness?.services;
export const getSearchedBusinesses =state => state.businessData.searchedBusinesses;